import { Observable } from 'rxjs';
import { TableContextMenuContainerDirective } from '../default-table/table-context-menu-container.directive';
import { TableContextMenuItem } from '../default-table/table-context-menu-item';
import { DefaultButtonsConfig } from './../../base-models/default-buttons-config';
import { Component, OnInit, EventEmitter, Output, Input, ChangeDetectorRef, ViewChild, HostListener, ElementRef } from '@angular/core';

@Component({
  selector: 'yt-fw-default-update-buttons',
  templateUrl: './default-update-buttons.component.html',
  styleUrls: ['./default-update-buttons.component.css']
})
export class DefaultUpdateButtonsComponent implements OnInit {

  constructor(
    private changeDetectorRef: ChangeDetectorRef,
    private elementRef: ElementRef
  ) { }

  showPrintButton: boolean = false;
  saveDisabled: boolean = false;
  isContextMenuVisible: boolean = false; 


  @Input('ShowPrintButton') set ShowPrintButton(value: boolean){
    this.showPrintButton = value;
    this.changeDetectorRef.detectChanges();
  }

  printButtonEnable: boolean = false;
  @Input('PrintButtonEnable') set PrintButtonEnable(value: boolean){
    this.printButtonEnable = value;
    this.changeDetectorRef.detectChanges();
  }

  lockedButton: boolean = false;
  @Input('LockedButton') set LockedButton(value: boolean){
    this.lockedButton = value;
    this.changeDetectorRef.detectChanges();
  }

  @Input() ButtonsConfig: DefaultButtonsConfig;
  @Input() ContextMenuItems: TableContextMenuItem[];

  // 01.04.2025
  private _isLoadingData = false;

  @Input('IsLoadingData') set IsLoadingData(value: boolean) {
    this._isLoadingData = value;
    this.disabledDueToLoad = value;
    this.changeDetectorRef.detectChanges();
  }
  
  @Output() SaveItemClicked = new EventEmitter();
  @Output() CloseItemClicked = new EventEmitter();
  @Output() AddItemClicked = new EventEmitter();
  @Output() SaveCloseItemClicked = new EventEmitter();
  @Output() PrintItemClicked = new EventEmitter();
  @Output() DeleteItemClicked = new EventEmitter();
  @Output() ResetItemClicked = new EventEmitter();
  @Output() LockUnLockClicked = new EventEmitter();

  @Output() ContextMenuItemClicked = new EventEmitter();
    @ViewChild(TableContextMenuContainerDirective, { static: false }) tableContextMenuContainer: TableContextMenuContainerDirective;

    @Output() TableContextMenuItemClicked = new EventEmitter();

    @Input() actionService: any; 
    @Input() modelData: any;
    @Input() ContextMenuIndicator: string; 

  get FilteredContextMenuItems(): TableContextMenuItem[] {
  const currentItem = this.actionService.baseUpdateComponent.Item;
  
  if (!currentItem) return [];

  return this.ContextMenuItems.filter(item =>
    
    (item.Indicator === this.ContextMenuIndicator || item.Indicator === 'global') &&
    (!item.IsVisibleFunction || item.IsVisibleFunction(currentItem))
  );

}
  // get FilteredContextMenuItems(): TableContextMenuItem[] {
  //     return this.ContextMenuItems.filter(item => item.Indicator === this.ContextMenuIndicator || item.Indicator === "global");
  // }

  public disabledDueToLoad: boolean = false;

  ngOnInit() {
  }

  
  OnSaveItem(){
    //this.saveDisabled = true;
    this.SaveItemClicked.emit();
    setTimeout(() => {
      //this.saveDisabled = false;
    }, 1000)
  }

  OnCloseItem(){
    this.CloseItemClicked.emit();
  }

  OnAddItem(){
    this.AddItemClicked.emit();
  }

  OnSaveCloseItem(){
    this.saveDisabled = true;
    this.SaveCloseItemClicked.emit();
    setTimeout(() => {
      this.saveDisabled = false;
    }, 1000)
  }

  OnPrintItem(){
    this.PrintItemClicked.emit();
  }

  OnDeleteItem(){
    this.DeleteItemClicked.emit();
  }

  OnReset(){
    this.ResetItemClicked.emit();
  }

  OnLockUnLockItem(){
    this.LockUnLockClicked.emit();
  }

get HasContextOptions(): boolean {
  const items = this.FilteredContextMenuItems;
  return Array.isArray(items) && items.length > 0;
}

ToggleContextMenu(event: MouseEvent): void {
  event.stopPropagation();
  if (!this.HasContextOptions) {
    return;
  }
  setTimeout(() => {
    this.isContextMenuVisible = !this.isContextMenuVisible;
    this.changeDetectorRef.detectChanges();
  });
}

OnContextMenuItemClicked(contextMenuItem: any) {
  const method = this.actionService[contextMenuItem.Action];

  if (typeof method === 'function') {
    let params: any[] = [];

    if (contextMenuItem.Parameters && typeof contextMenuItem.Parameters === 'object') {
      params = Object.keys(contextMenuItem.Parameters).map(key => {
        const value = contextMenuItem.Parameters[key];

        if (typeof value === 'string' && value.includes('.')) {
          const resolvedFromService = this.resolvePath(this.actionService, value);
          if (resolvedFromService !== undefined) return resolvedFromService;
          return this.resolvePath(this, value);
        }

        return value;
      });
    }

    method.apply(this.actionService, params);
  } else {
    console.warn(`Metoda ${contextMenuItem.Action} ne postoji u prosleđenom servisu.`);
  }

  this.isContextMenuVisible = false;
}

  private resolvePath(obj: any, path: string): any {
  return path.split('.').reduce((acc, key) => acc && acc[key], obj);
}


  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent): void {
    const clickedInside = this.elementRef.nativeElement.contains(event.target);
    if (!clickedInside && this.isContextMenuVisible) {
      this.isContextMenuVisible = false;  
      this.changeDetectorRef.detectChanges();
    }
  }
}
